export const streets = [
  { value: "agrestowa", label: "Agrestowa", id: "street" },
  { value: "akacjowa", label: "Akacjowa", id: "street" },
  { value: "adama asynka", label: "Adama Asynka", id: "street" },
  { value: "bolesława chrobrego", label: "Bolesława Chrobrego", id: "street" },
  { value: "bolesława krzywoustego", label: "Bolesława Krzywoustego", id: "street" },
  { value: "bolesława śmiałego", label: "Bolesława Śmiałego", id: "street" },
  { value: "tadeusza boya-zeleńskiego", label: "Tadeusza Boya-Zeleńskiego", id: "street" },
  { value: "mariana brandysa", label: "Mariana Brandysa", id: "street" },
  { value: "jana brzechwy", label: "Jana Brzechwy", id: "street" },
  { value: "brzoskwiniowa", label: "Brzoskwiniowa", id: "street" },
  { value: "brzozowa", label: "Brzozowa", id: "street" },
  { value: "rondo budzyń", label: "rondo Budzyń", id: "street" },
  { value: "budzyńska", label: "Budzyńska", id: "street" },
  { value: "bukowa", label: "Bukowa", id: "street" },
  { value: "Cedrowa", label: "Cedrowa", id: "street" },
  { value: "cegielniana", label: "Cegielniana", id: "street" },
  { value: "aliny i czesława centkiewicz", label: "Aliny i Czesława Centkiewicz", id: "street" },
  { value: "józefa chełmońskiego", label: "Józefa Chełmońskiego", id: "street" },
  { value: "chodkiewicza", label: "Chodkiewicza", id: "street" },
  { value: "chopina", label: "Chopina", id: "street" },
  { value: "cisowa", label: "Cisowa", id: "street" },
  { value: "jana cybisa", label: "Jana Cybisa", id: "street" },
  { value: "czajkowskiego", label: "Czajkowskiego", id: "street" },
  { value: "czarnieckiego", label: "Czarnieckiego", id: "street" },
  { value: "czarnokurz", label: "Czarnokurz", id: "street" },
  { value: "czereśniowa", label: "Czereśniowa", id: "street" },
  { value: "czwartaków", label: "Czwartaków", id: "street" },
  { value: "marii dąbrowskiej", label: "Marii Dąbrowskiej", id: "street" },
  { value: "dębowa", label: "Dębowa", id: "street" },
  { value: "dembowskiego", label: "Dembowskiego", id: "street" },
  { value: "długa", label: "Długa", id: "street" },
  { value: "janusza domagalika", label: "Janusza Domagalika", id: "street" },
  { value: "dworcowa", label: "Dworcowa", id: "street" },
  { value: "juliana fałata", label: "Juliana Fałata", id: "street" },
  { value: "farbiarska", label: "Farbiarska", id: "street" },
  { value: "fiedlera", label: "Fiedlera", id: "street" },
  { value: "aleksandra fredry", label: "Aleksandra Fredry", id: "street" },
  { value: "gajowa", label: "Gajowa", id: "street" },
  { value: "gałczyńskiego", label: "Gałczyńskiego", id: "street" },
  { value: "garbarska", label: "Garbarska", id: "street" },
  { value: "aleksandra gierymskiego", label: "Aleksandra Gierymskiego", id: "street" },
  { value: "glinki", label: "Glinki", id: "street" },
  { value: "głogowa", label: "Głogowa", id: "street" },
  { value: "witolda gombrowicza", label: "Witolda Gombrowicza", id: "street" },
  { value: "kazimierza górskiego", label: "Kazimierza Górskiego", id: "street" },
  { value: "grabowa", label: "Grabowa", id: "street" },
  { value: "artura grottgera", label: "Artura Grottgera", id: "street" },
  { value: "gruszkowa", label: "Gruszkowa", id: "street" },
  { value: "harcerska", label: "Harcerska", id: "street" },
  { value: "kazimiery iłłakowiczówny", label: "Kazimiery Iłłakowiczówny", id: "street" },
  { value: "jarosława iwaszkiewicza", label: "Jarosława Iwaszkiewicza", id: "street" },
  { value: "jabłkowa", label: "Jabłkowa", id: "street" },
  { value: "królowej jadwigi", label: "Królowej Jadwigi", id: "street" },
  { value: "jagodowa", label: "Jagodowa", id: "street" },
  { value: "jałowcowa", label: "Jałowcowa", id: "street" },
  { value: "jana III sobieskiego", label: "Jana III Sobieskiego", id: "street" },
  { value: "jarzynowa", label: "Jarzynowa", id: "street" },
  { value: "jasna", label: "Jasna", id: "street" },
  { value: "jaworowa", label: "Jaworowa", id: "street" },
  { value: "jesionowa", label: "Jesionowa", id: "street" },
  { value: "jeziorna", label: "Jeziorna", id: "street" },
  { value: "jodłowa", label: "Jodłowa", id: "street" },
  { value: "ireny jurgielewiczowej", label: "Ireny Jurgielewiczowej", id: "street" },
  { value: "stefana kałamajskiego", label: "Stefana Kałamajskiego", id: "street" },
  { value: "kalinowa", label: "Kalinowa", id: "street" },
  { value: "kanałowa", label: "Kanałowa", id: "street" },
  { value: "kasprowicza", label: "Kasprowicza", id: "street" },
  { value: "kasztanowa", label: "Kasztanowa", id: "street" },
  { value: "kazimierza jagiellończyka", label: "Kazimierza Jagiellończyka", id: "street" },
  { value: "kazimierza odnowiciela", label: "Kazimierza Odnowiciela", id: "street" },
  { value: "kazimierza wielkiego", label: "Kazimierza Wielkiego", id: "street" },
  { value: "kilińskiego", label: "Kilińskiego", id: "street" },
  { value: "klonowa", label: "Klonowa", id: "street" },
  { value: "katarzyny kobro", label: "Katarzyny Kobro", id: "street" },
  { value: "kolejowa", label: "Kolejowa", id: "street" },
  { value: "kołłątaja", label: "Kołłątaja", id: "street" },
  { value: "władysława komara", label: "Władysława Komara", id: "street" },
  { value: "konopnickiej", label: "Konopnickiej", id: "street" },
  { value: "kopernika", label: "Kopernika", id: "street" },
  { value: "kościelna", label: "Kościelna", id: "street" },
  { value: "kościuszki", label: "Kościuszki", id: "street" },
  { value: "wojciecha kossaka", label: "Wojciecha Kossaka", id: "street" },
  { value: "marii kownackiej", label: "Marii Kownackiej", id: "street" },
  { value: "krańcowa", label: "Krańcowa", id: "street" },
  { value: "krasickiego", label: "Krasickiego", id: "street" },
  { value: "krosińska", label: "Krosińska", id: "street" },
  { value: "krótka", label: "Krótka", id: "street" },
  { value: "krotowskiego", label: "Krotowskiego", id: "street" },
  { value: "marii kuncewiczowej", label: "Marii Kuncewiczowej", id: "street" },
  { value: "janusza kusocińskiego", label: "Janusza Kusocińskiego", id: "street" },
  { value: "kwiatowa", label: "Kwiatowa", id: "street" },
  { value: "łąkowa", label: "Łąkowa", id: "street" },
  { value: "henryka łasaka", label: "Henryka Łasaka", id: "street" },
  { value: "łazienna", label: "Łazienna", id: "street" },
  { value: "stanisława lema", label: "Stanisława Lema", id: "street" },
  { value: "leśmiana", label: "Leśmiana", id: "street" },
  { value: "leśna", label: "Leśna", id: "street" },
  { value: "leszczyńska", label: "Leszczyńska", id: "street" },
  { value: "kornela makuszyńskiego", label: "Kornela Makuszyńskiego", id: "street" },
  { value: "jacka malczewskiego", label: "Jacka Malczewskiego", id: "street" },
  { value: "bronisława malinowskiego", label: "Bronisława Malinowskiego", id: "street" },
  { value: "marcinkowskiego", label: "Marcinkowskiego", id: "street" },
  { value: "stanisława marusarza", label: "Stanisława Marusarza", id: "street" },
  { value: "jana matejki", label: "Jana Matejki", id: "street" },
  { value: "mickiewicza", label: "Mickiewicza", id: "street" },
  { value: "mieszka", label: "Mieszka I", id: "street" },
  { value: "miła", label: "Miła", id: "street" },
  { value: "piotra mocka", label: "Piotra Mocka", id: "street" },
  { value: "modrzewiowa", label: "Modrzewiowa", id: "street" },
  { value: "mokra", label: "Mokra", id: "street" },
  { value: "moniuszki", label: "Moniuszki", id: "street" },
  { value: "morelowa", label: "Morelowa", id: "street" },
  { value: "mostowa", label: "Mostowa", id: "street" },
  { value: "na wzgórzu", label: "Na Wzgórzu", id: "street" },
  { value: "zofii nałkowskiej", label: "Zofii Nałkowskiej", id: "street" },
  { value: "juliana ursyna niemcewicza", label: "Juliana Ursyna Niemcewicza", id: "street" },
  { value: "niepodległości", label: "Niepodległości", id: "street" },
  { value: "niezłomnych", label: "Niezłomnych", id: "street" },
  { value: "nizinna", label: "Nizinna", id: "street" },
  { value: "cypriana kamila norwida", label: "Cypriana Kamila Norwida", id: "street" },
  { value: "nowa", label: "Nowa", id: "street" },
  { value: "nowowiejskiego", label: "Nowowiejskiego", id: "street" },
  { value: "obrzańska", label: "Obrzańska", id: "street" },
  { value: "marianaobsta", label: "Mariana Obsta", id: "street" },
  { value: "ogrodowa", label: "Ogrodowa", id: "street" },
  { value: "olchowa", label: "Olchowa", id: "street" },
  { value: "orzeszkowej", label: "Orzeszkowej", id: "street" },
  { value: "osiedlowa", label: "Osiedlowa", id: "street" },
  { value: "paderewskiego", label: "Paderewskiego", id: "street" },
  { value: "piaskowa", label: "Piaskowa", id: "street" },
  { value: "plac 20 października", label: "Plac 20 Października", id: "street" },
  { value: "platanowa", label: "Platanowa", id: "street" },
  { value: "podgórna", label: "Podgórna", id: "street" },
  { value: "poniatowskiego", label: "Poniatowskiego", id: "street" },
  { value: "janiny porazińskiej", label: "Janiny Porazińskiej", id: "street" },
  { value: "porzeczkowa", label: "Porzeczkowa", id: "street" },
  { value: "powstańców wielkopolskich", label: "Powstańców Wielkopolskich", id: "street" },
  { value: "pożegowska", label: "Pożegowska", id: "street" },
  { value: "poziomkowa", label: "Poziomkowa", id: "street" },
  { value: "poznańska", label: "Poznańska", id: "street" },
  { value: "prusa", label: "Prusa", id: "street" },
  { value: "ptasia", label: "Ptasia", id: "street" },
  { value: "reja", label: "Reja", id: "street" },
  { value: "reymonta", label: "Reymonta", id: "street" },
  { value: "wincentego różańskiego", label: "Wincentego Różańskiego", id: "street" },
  { value: "rzeczna", label: "Rzeczna", id: "street" },
  { value: "rzeczypospolitej mosińskiej", label: "Rzeczypospolitej Mosińskiej", id: "street" },
  { value: "bruno schulza", label: "Bruno Schulza", id: "street" },
  { value: "henryka siemiradzkiego", label: "Henryka Siemiradzkiego", id: "street" },
  { value: "sienkiewicza", label: "Sienkiewicza", id: "street" },
  { value: "skrajna", label: "Skrajna", id: "street" },
  { value: "skryta", label: "Skryta", id: "street" },
  { value: "skrzynecka", label: "Skrzynecka", id: "street" },
  { value: "śliwkowa", label: "Śliwkowa", id: "street" },
  { value: "słoneczna", label: "Słoneczna", id: "street" },
  { value: "słowackiego", label: "Słowackiego", id: "street" },
  { value: "tadeusza ślusarskiego", label: "Tadeusza Ślusarskiego", id: "street" },
  { value: "sosnowa", label: "Sosnowa", id: "street" },
  { value: "sowiniecka", label: "Sowiniecka", id: "street" },
  { value: "sowińskiego", label: "Sowińskiego", id: "street" },
  { value: "spacerowa", label: "Spacerowa", id: "street" },
  { value: "spokojna", label: "Spokojna", id: "street" },
  { value: "śremska", label: "Śremska", id: "street" },
  { value: "leopolda staffa", label: "Leopolda Staffa", id: "street" },
  { value: "feliksa stamma", label: "Feliksa Stamma", id: "street" },
  { value: "stefana batorego", label: "Stefana Batorego", id: "street" },
  { value: "biskupa franciszka stefanowicza", label: "Biskupa Franciszka Stefanowicza", id: "street" },
  { value: "zofii stryjeńskiej", label: "Zofii Stryjeńskiej", id: "street" },
  { value: "strzałowa", label: "Strzałowa", id: "street" },
  { value: "strzelecka", label: "Strzelecka", id: "street" },
  { value: "władysława strzemińskiego", label: "Władysława Strzemińskiego", id: "street" },
  { value: "studzienna", label: "Studzienna", id: "street" },
  { value: "świerkowa", label: "Świerkowa", id: "street" },
  { value: "alfreda szklarskiego", label: "Alfreda Szklarskiego", id: "street" },
  { value: "szkolna", label: "Szkolna", id: "street" },
  { value: "szosa poznańska", label: "Szosa Poznańska", id: "street" },
  { value: "szpakowa", label: "Szpakowa", id: "street" },
  { value: "szyszkowa", label: "Szyszkowa", id: "street" },
  { value: "targowa", label: "Targowa", id: "street" },
  { value: "topolowa", label: "Topolowa", id: "street" },
  { value: "torowa", label: "Torowa", id: "street" },
  { value: "juliana tuwima", label: "Juliana Tuwima", id: "street" },
  { value: "tylna", label: "Tylna", id: "street" },
  { value: "huberta wagnera", label: "Huberta Wagnera", id: "street" },
  { value: "pułkownika aleksandra wańkowicza", label: "Pułkownika Aleksandra Wańkowicza", id: "street" },
  { value: "wąska", label: "Wąska", id: "street" },
  { value: "wawrzyniaka", label: "Wawrzyniaka", id: "street" },
  { value: "wiatrowa", label: "Wiatrowa", id: "street" },
  { value: "wiejska", label: "Wiejska", id: "street" },
  { value: "wieniawskiego", label: "Wieniawskiego", id: "street" },
  { value: "wierzbowa", label: "Wierzbowa", id: "street" },
  { value: "wiosny ludów", label: "Wiosny Ludów", id: "street" },
  { value: "wiśniowa", label: "Wiśniowa", id: "street" },
  { value: "władysława jagiełły", label: "Władysława Jagiełły", id: "street" },
  { value: "władysława łokietka", label: "Władysława Łokietka", id: "street" },
  { value: "wodna", label: "Wodna", id: "street" },
  { value: "wrzosowa", label: "Wrzosowa", id: "street" },
  { value: "wybickiego", label: "Wybickiego", id: "street" },
  { value: "leona wyczółkowskiego", label: "Leona Wyczółkowskiego", id: "street" },
  { value: "wysoka", label: "Wysoka", id: "street" },
  { value: "stanisława wyspiańskiego", label: "Stanisława Wyspiańskiego", id: "street" },
  { value: "gabrieli zapolskiej", label: "Gabrieli Zapolskiej", id: "street" },
  { value: "żeromskiego", label: "Żeromskiego", id: "street" },
  { value: "zieleniec", label: "Zieleniec", id: "street" },
  { value: "aksamitkowa", label: "Aksamitkowa", id: "street" },
  { value: "gerberowa", label: "Gerberowa", id: "street" },
  { value: "hiacyntowa", label: "Hiacyntowa", id: "street" },
  { value: "jarzębinowa", label: "Jarzębinowa", id: "street" },
  { value: "krokusowa", label: "Krokusowa", id: "street" },
  { value: "malwowa", label: "Malwowa", id: "street" },
  { value: "morwowa", label: "Morwowa", id: "street" },
  { value: "tulipanowa", label: "Tulipanowa", id: "street" },
  { value: "żniwna", label: "Żniwna", id: "street" },
  { value: "polna", label: "Polna", id: "street" },
  { value: "bajkowa", label: "Bajkowa", id: "street" },
  { value: "chabrowa", label: "Chabrowa", id: "street" },
  { value: "jaskrowa", label: "Jaskrowa", id: "street" },
  { value: "kaczeńcowa", label: "Kaczeńcowa", id: "street" },
  { value: "lawendowa", label: "Lawendowa", id: "street" },
  { value: "łubinowa", label: "Łubinowa", id: "street" },
  { value: "makowa", label: "Makowa", id: "street" },
  { value: "odległa", label: "Odległa", id: "street" },
  { value: "powojnikowa", label: "Powojnikowa", id: "street" },
  { value: "słonecznikowa", label: "Słonecznikowa", id: "street" },
  { value: "śródpolna", label: "Śródpolna", id: "street" },
  { value: "mosińska", label: "Mosińska", id: "street" },
  { value: "bazyliowa", label: "Bazyliowa", id: "street" },
  { value: "choinkowa", label: "Choinkowa", id: "street" },
  { value: "cicha", label: "Cicha", id: "street" },
  { value: "graniczna", label: "Graniczna", id: "street" },
  { value: "jaśminowa", label: "Jaśminowa", id: "street" },
  { value: "koperkowa", label: "Koperkowa", id: "street" },
  { value: "korzenna", label: "Korzenna", id: "street" },
  { value: "ogrodnicza", label: "Ogrodnicza", id: "street" },
  { value: "okrężna", label: "Okrężna", id: "street" },
  { value: "pod lasem", label: "Pod Lasem", id: "street" },
  { value: "szafirowa", label: "Szafirowa", id: "street" },
  { value: "szafranowa", label: "Szafranowa", id: "street" },
  { value: "taborowa", label: "Taborowa", id: "street" },
  { value: "widokowa", label: "Widokowa", id: "street" },
  { value: "wspólna", label: "Wspólna", id: "street" },
  { value: "zacisze", label: "Zacisze", id: "street" },
  { value: "ziołowa", label: "Ziołowa", id: "street" },
  { value: "kocankowa", label: "Kocankowa", id: "street" },
  { value: "łódzka", label: "Łódzka", id: "street" },
  { value: "miętowa", label: "Miętowa", id: "street" },
  { value: "piołunowa", label: "Piołunowa", id: "street" },
  { value: "pod topolami", label: "Pod Topolami", id: "street" },
  { value: "pogodna", label: "Pogodna", id: "street" },
  { value: "prusak", label: "Bolesławy Prusak", id: "street" },
  { value: "radosna", label: "Radosna", id: "street" },
  { value: "rumiankowa", label: "Rumiankowa", id: "street" },
  { value: "skrzypowa", label: "Skrzypowa", id: "street" },
  { value: "szczęśliwa", label: "Szczęśliwa", id: "street" },
  { value: "szmaragdowa", label: "Szmaragdowa", id: "street" },
  { value: "wczasowa", label: "Wczasowa", id: "street" },
  { value: "wincentego witosa", label: "Wincentego Witosa", id: "street" },
  { value: "wrotyczowa", label: "Wrotyczowa", id: "street" },
  { value: "żeglarska", label: "żeglarska", id: "street" },
  { value: "aroniowa", label: "Aroniowa", id: "street" },
  { value: "bajera", label: "Bajera", id: "street" },
  { value: "dereniowa", label: "Dereniowa", id: "street" },
  { value: "nad stawem", label: "Nad Stawem", id: "street" },
  { value: "ognikowa", label: "Ognikowa", id: "street" },
  { value: "przy parku", label: "Przy Parku", id: "street" },
  { value: "stokrotkowa", label: "Stokrotkowa", id: "street" },
  { value: "wiosenna", label: "Wiosenna", id: "street" },
  { value: "azaliowa", label: "Azaliowa", id: "street" },
  { value: "borowikowa", label: "Borowikowa", id: "street" },
  { value: "czeremchowa", label: "Czeremchowa", id: "street" },
  { value: "górecka", label: "Górecka", id: "street" },
  { value: "grzybowa", label: "Grzybowa", id: "street" },
  { value: "kociołek", label: "Kociołek", id: "street" },
  { value: "kozakowa", label: "Kozakowa", id: "street" },
  { value: "lipowa", label: "Lipowa", id: "street" },
  { value: "ludwikowska", label: "Ludwikowska", id: "street" },
  { value: "magnoliowa", label: "Magnoliowa", id: "street" },
  { value: "malinowa", label: "Malinowa", id: "street" },
  { value: "nad potokiem", label: "Nad Potokiem", id: "street" },
  { value: "orzechowa", label: "Orzechowa", id: "street" },
  { value: "parkowa", label: "Parkowa", id: "street" },
  { value: "różana", label: "Różana", id: "street" },
  { value: "skrzynka", label: "Skrzynka", id: "street" },
  { value: "stęszewska", label: "Stęszewska", id: "street" },
  { value: "warzywna", label: "Warzywna", id: "street" },
  { value: "wodziczki", label: "Wodziczki", id: "street" },
  { value: "zamoyskiego", label: "Zamoyskiego", id: "street" },
  { value: "zielona", label: "Zielona", id: "street" },
  { value: "boczna", label: "Boczna", id: "street" },
  { value: "główna", label: "Główna", id: "street" },
  { value: "jesienna", label: "Jesienna", id: "street" },
  { value: "kamienna", label: "Kamienna", id: "street" },
  { value: "krzemionkowa", label: "Krzemionkowa", id: "street" },
  { value: "miodowa", label: "Miodowa", id: "street" },
  { value: "nadleśna", label: "Nadleśna", id: "street" },
  { value: "nektarowa", label: "Nektarowa", id: "street" },
  { value: "olszynkowa", label: "Olszynkowa", id: "street" },
  { value: "osiedle miodowe", label: "Osiedle Miodowe", id: "street" },
  { value: "osiedle olszynka", label: "Osiedle Olszynka", id: "street" },
  { value: "przemysłowa", label: "Przemysłowa", id: "street" },
  { value: "rzemieślnicza", label: "Rzemieślnicza", id: "street" },
  { value: "tęczowa", label: "Tęczowa", id: "street" },
  { value: "żwirowa", label: "Żwirowa", id: "street" },
  { value: "jordanowska", label: "Jordanowska", id: "street" },
  { value: "gryczana", label: "Gryczana", id: "street" },
  { value: "rolna", label: "Rolna", id: "street" },
  { value: "zbożowa", label: "Zbożowa", id: "street" },
  { value: "bieczyńska", label: "Bieczyńska", id: "street" },
  { value: "daglezjowa", label: "Daglezjowa", id: "street" },
  { value: "jemiołowa", label: "Jemiołowa", id: "street" },
  { value: "kozia", label: "Kozia", id: "street" },
  { value: "sielska", label: "Sielska", id: "street" },
  { value: "strażacka", label: "Strażacka", id: "street" },
  { value: "ustronna", label: "Ustronna", id: "street" },
  { value: "wąska", label: "Wąska", id: "street" },
  { value: "kosynierów", label: "Kosynierów", id: "street" },
  { value: "arciszewskiego", label: "Arciszewskiego", id: "street" },
  { value: "nowa", label: "Nowa", id: "street" },
  { value: "osada", label: "Osada", id: "street" },
  { value: "podleśna", label: "Podleśna", id: "street" },
  { value: "prezydialna", label: "Prezydialna", id: "street" },
  { value: "kostrzewskiego", label: "Kostrzewskiego", id: "street" },
  { value: "kręta", label: "Kręta", id: "street" },
  { value: "olszynowa", label: "Olszynowa", id: "street" },
  { value: "północna", label: "Północna", id: "street" },
  { value: "powozowa", label: "Powozowa", id: "street" },
  { value: "generała sikorskiego", label: "Generała Sikorskiego", id: "street" },
  { value: "lucyny smok", label: "Lucyny Smok", id: "street" },
  { value: "mniszkowa", label: "Mniszkowa", id: "street" },
  { value: "andersonów", label: "Andersonów", id: "street" },
  { value: "bałtycka", label: "Bałtycka", id: "street" },
  { value: "gen. józefa bema", label: "Gen. Józefa Bema", id: "street" },
  { value: "ryszarda berwińskiego", label: "Ryszarda Berwińskiego", id: "street" },
  { value: "cienista", label: "Cienista", id: "street" },
  { value: "czarna", label: "Czarna", id: "street" },
  { value: "gen. dąbrowskiego", label: "Gen. Dąbrowskiego", id: "street" },
  { value: "prof. izabeli dąmbskiej", label: "prof. Izabeli Dąmbskiej", id: "street" },
  { value: "agrestowa", label: "Agrestowa", id: "street" },
  { value: "deierlinga", label: "Deierlinga", id: "street" },
  { value: "fiołkowa", label: "Fiołkowa", id: "street" },
  { value: "gliniana", label: "Gliniana", id: "street" },
  { value: "gołębia", label: "Gołębia", id: "street" },
  { value: "grochowa", label: "Grochowa", id: "street" },
  { value: "grunwaldzka", label: "Grunwaldzka", id: "street" },
  { value: "gwarna", label: "Gwarna", id: "street" },
  { value: "helska", label: "Helska", id: "street" },
  { value: "hotelowa", label: "Hotelowa", id: "street" },
  { value: "maksymiliana jackowskiego", label: "Maksymiliana Jackowskiego", id: "street" },
  { value: "jałowcowa", label: "Jałowcowa", id: "street" },
  { value: "zygmunta janaszka", label: "Zygmunta Janaszka", id: "street" },
  { value: "jarosławska", label: "Jarosławska", id: "street" },
  { value: "jaskółcza", label: "Jaskółcza", id: "street" },
  { value: "jastrzębia", label: "Jastrzębia", id: "street" },
  { value: "jeździecka", label: "Jeździecka", id: "street" },
  { value: "klasztorna", label: "Klasztorna", id: "street" },
  { value: "jana kochanowskiego", label: "Jana Kochanowskiego", id: "street" },
  { value: "konwaliowa", label: "Konwaliowa", id: "street" },
  { value: "władysława kosińskiego", label: "Władysława Kosińskiego", id: "street" },
  { value: "kosynierów miłosławskich", label: "Kosynierów Miłosławskich", id: "street" },
  { value: "krzywa", label: "Krzywa", id: "street" },
  { value: "józefa ignacego kraszewskiego", label: "Józefa Ignacego Kraszewskiego", id: "street" },
  { value: "juliana langego", label: "Juliana Langego", id: "street" },
  { value: "karola libelta", label: "Karola Libelta", id: "street" },
  { value: "lodowcowa", label: "Lodowcowa", id: "street" },
  { value: "józefa łukaszewicza", label: "Józefa Łukaszewicza", id: "street" },
  { value: "magazynowa", label: "Magazynowa", id: "street" },
  { value: "3 maja", label: "3 Maja", id: "street" },
  { value: "mazurska", label: "Mazurska", id: "street" },
  { value: "morenowa", label: "Morenowa", id: "street" },
  { value: "myśliwska", label: "Myśliwska", id: "street" },
  { value: "na skarpie", label: "Na Skarpie", id: "street" },
  { value: "nadwarciańska", label: "Nadwarciańska", id: "street" },
  { value: "narcyzowa", label: "Narcyzowa", id: "street" },
  { value: "niwka stara", label: "Niwka Stara", id: "street" },
  { value: "nowe osiedle", label: "Nowe Osiedle", id: "street" },
  { value: "odskok", label: "Odskok", id: "street" },
  { value: "piękna", label: "Piękna", id: "street" },
  { value: "piesza", label: "Piesza", id: "street" },
  { value: "pomorska", label: "Pomorska", id: "street" },
  { value: "ks. ignacego posadzego", label: "ks. Ignacego Posadzego", id: "street" },
  { value: "przecznica", label: "Przecznica", id: "street" },
  { value: "przy murze", label: "Przy Murze", id: "street" },
  { value: "przyszkolna", label: "Przyszkolna", id: "street" },
  { value: "pszeniczna", label: "Pszeniczna", id: "street" },
  { value: "kazimierza pułaskiego", label: "Kazimierza Pułaskiego", id: "street" },
  { value: "cyryla ratajskiego", label: "Cyryla Ratajskiego", id: "street" },
  { value: "robocza", label: "Robocza", id: "street" },
  { value: "rynek", label: "Rynek", id: "street" },
  { value: "rządowa", label: "Rządowa", id: "street" },
  { value: "sadowa", label: "Sadowa", id: "street" },
  { value: "sasankowa", label: "Sasankowa", id: "street" },
  { value: "sielankowa", label: "Sielankowa", id: "street" },
  { value: "śląska", label: "Śląska", id: "street" },
  { value: "słowicza", label: "Słowicza", id: "street" },
  { value: "sokoła", label: "Sokoła", id: "street" },
  { value: "ludwika solskiego", label: "Ludwika Solskiego", id: "street" },
  { value: "sowia", label: "Sowia", id: "street" },
  { value: "sportowa", label: "Sportowa", id: "street" },
  { value: "środkowa", label: "Środkowa", id: "street" },
  { value: "stroma", label: "Stroma", id: "street" },
  { value: "studzienna", label: "Studzienna", id: "street" },
  { value: "szpitalna", label: "Szpitalna", id: "street" },
  { value: "tenisowa", label: "Tenisowa", id: "street" },
  { value: "urocza", label: "Urocza", id: "street" },
  { value: "piotra wawrzyniaka", label: "Piotra Wawrzyniaka", id: "street" },
  { value: "wiązowa", label: "Wiązowa", id: "street" },
  { value: "wydmowa", label: "Wydmowa", id: "street" },
  { value: "zalesie", label: "Zalesie", id: "street" },
  { value: "brata józefa zapłaty", label: "Brata Józefa Zapłaty", id: "street" },
  { value: "zaułek", label: "Zaułek", id: "street" },
  { value: "źródlana", label: "Źródlana", id: "street" },
  { value: "jana żupańskiego", label: "Jana Żupańskiego", id: "street" },
  { value: "żytnia", label: "Żytnia", id: "street" },
  { value: "trzebawska", label: "Trzebawska", id: "street" },
  { value: "wypoczynkowa", label: "Wypoczynkowa", id: "street" },
  { value: "zgodna", label: "Zgodna", id: "street" },
  { value: "rubinowa", label: "Rubinowa", id: "street" },
  { value: "wrocławska", label: "Wrocławska", id: "street" },
];